import React from "react";
import { zodResolver } from "@hookform/resolvers/zod";

import { z } from "zod";
import { useForm } from "react-hook-form";

import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/uiComponents/components/ui/form";
import { Input } from "@/uiComponents/components/ui/input";

import { useDispatch, useSelector } from "react-redux";

import { RootState } from "@/store/store";
import { setLoading } from "@/store/redux/appSlice";

import { itemSchema } from "@/utils/schemaHelper";

import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/uiComponents/components/ui/dialog";

import { ErrorHelper } from "@/utils/errorHelper";
import { toastMessage } from "@/utils/toastHelper";
import { ReusableButton } from "@/reusable/reusableButton";
import { createItemApi, getItemApi } from "@/modules/organizationServices";
import { setItems } from "@/store/redux/organization/itemSlice";
import { ItemSuccess } from "@/enums/errorMessages";
import { addItemProps } from "@/types/organization";

const AddItems: React.FC<addItemProps> = ({ onClose, isOpen }) => {
  if (!isOpen) return null;
  const dispatch = useDispatch();

  const loading = useSelector((state: RootState) => state.app.loading);
  const userDetails = useSelector(
    (state: RootState) => state.userDetail.userDetail,
  );

  const orgId = userDetails?.organizationId;

  const form = useForm<z.infer<typeof itemSchema>>({
    resolver: zodResolver(itemSchema),
    mode: "onChange",
    defaultValues: {
      name: "",
      organization: userDetails?.organizationId,
    },
  });

  const getItems = async () => {
    try {
      const res = await getItemApi();
      const response = res.items;
      if (response != undefined) {
        const items = Array.isArray(response) ? response : [response];
        dispatch(setItems(items));
      }
    } catch (error) {
      const actualError = ErrorHelper(error);
      const message = Array.isArray(actualError) ? actualError[0] : actualError;
      toastMessage("error", message);
    }
  };

  const onSubmit = async (values: z.infer<typeof itemSchema>) => {
    if (loading) return;
    dispatch(setLoading(true));

    try {
      if (!orgId) {
        return;
      }

      await createItemApi(values);
      getItems();
      onClose();

      toastMessage("success", ItemSuccess.ITEM_CREATED);
    } catch (error) {
      const actualError = ErrorHelper(error);
      const message = Array.isArray(actualError) ? actualError[0] : actualError;
      toastMessage("error", message);
    } finally {
      dispatch(setLoading(false));
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[500px]">
        <DialogHeader>
          <DialogTitle>Add Item</DialogTitle>
        </DialogHeader>

        <Form {...form}>
          <form
            onSubmit={form.handleSubmit(onSubmit)}
            className="space-y-6 mt-5"
          >
            <FormField
              control={form.control}
              name="name"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>Name</FormLabel>

                  <FormControl>
                    <Input
                      className="bg-white"
                      {...field}
                      placeholder="Enter item name"
                    />
                  </FormControl>

                  <FormMessage className="text-xs mt-1" />
                </FormItem>
              )}
            />
            <FormField
              control={form.control}
              name="organization"
              render={({ field }) => (
                <FormItem>
                  <FormLabel hidden>Organization</FormLabel>
                  <FormControl>
                    <Input hidden {...field} />
                  </FormControl>
                </FormItem>
              )}
            />

            <div className="flex justify-center mt-4 mr-2">
              <ReusableButton
                label="Add"
                className=" mt-5 mb-2 "
                loading={loading}
              />
            </div>
          </form>
        </Form>
      </DialogContent>
    </Dialog>
  );
};
export default AddItems;
